import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconFillCheckCircle = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--fill-check-circle")} iconColor={color} size={size} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M1 12C1 5.928 5.928 1 12 1s11 4.928 11 11-4.928 11-11 11S1 18.072 1 12zm4.07.77 3.949 3.949a1.095 1.095 0 0 0 1.551 0l8.349-8.349a1.095 1.095 0 0 0 0-1.551 1.095 1.095 0 0 0-1.551 0L9.8 14.387l-3.179-3.168a1.095 1.095 0 0 0-1.551 0 1.095 1.095 0 0 0 0 1.551z" fill="currentColor"/>
  </IconWrapper>
)
